import { Fragment } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import LoadingIndicator from 'atoms/loader/LoadingIndicator';
import { Text16 } from 'atoms/typography';
import RecommendedWalletApp from 'components/wallet/RecommendedWalletApp';
import { useBlockchainContext } from 'contexts/blockchain';
import { glossary } from 'lib/glossary';

const messages = defineMessages({
  wrongNetwork: {
    id: 'ConnectPrivateWallet.wrongNetwork',
    defaultMessage:
      'Please switch your Wallet to the Ethereum {expectedEthereumNetwork} network.',
  },
});

const Warning = styled(Text16)`
  padding: 10px;
  color: var(--c-neutral-600);
  border-radius: 8px;
  background: var(--c-neutral-200);
`;

export const ConnectPrivateWallet = () => {
  const {
    expectedEthereumNetwork,
    connectors,
    isConnected,
    loading,
    activeConnector,
    wrongChain,
    connectToEthereum,
    reset,
  } = useBlockchainContext();

  if (loading) {
    return (
      <>
        <LoadingIndicator />
        <Button onClick={reset} size="medium" color="secondary">
          <FormattedMessage {...glossary.cancel} />
        </Button>
      </>
    );
  }

  if (connectors.length === 0 && !activeConnector) {
    return <RecommendedWalletApp />;
  }

  if (wrongChain) {
    return (
      <Warning>
        <FormattedMessage
          {...messages.wrongNetwork}
          values={{ expectedEthereumNetwork }}
        />
      </Warning>
    );
  }
  if (isConnected) return null;

  return connectors.map(connector => (
    <Fragment key={connector.id}>
      <Button
        fullWidth
        size="medium"
        color="primary"
        onClick={() => connectToEthereum(connector)}
      >
        <FormattedMessage
          id="ConnectPrivateWallet.connect"
          defaultMessage="Connect my {name} wallet"
          values={{ name: connector.name }}
        />
      </Button>
    </Fragment>
  ));
};

export default ConnectPrivateWallet;
